<template>
  <v-footer color="#cecece" class="footerWeb" v-if="$mq === 'desktop'">
    <v-col align="center" class="col-6">
      <v-row id="contenedorSuperior" align="center" justify="center">
        <v-col>
          <a id="aytoCas" :href="urlCastropol">
          <v-img
            contain
            :src="castropol"
            width="50em"
            max-width="200px"
          ></v-img>
        </a>
        </v-col>
        <v-col>
          <a id="aytoCas" :href="urlCastropol">
          <v-img
            contain
            :src="ayuntamiento"
            width="50em"
            max-width="200px"
          ></v-img>
        </a>
        </v-col>
        
      </v-row>
    </v-col>
    <v-col class="col-6">
      <v-row>
        <v-col>
          <v-card-text>
            <v-col align="center" justify="center">
              <strong>Contacto</strong><br />
              Plaza del Ayuntamiento s/n<br />
              33760 - Castropol Asturias<br />
              985 635 001<br />
              <a href="mailto: ayuntamiento@castropol.es"
                >ayuntamiento@castropol.es</a
              ><br />
            </v-col>
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text>
            <v-col align="center">
              <a :href="avisoLegal">Aviso legal</a><br />
              <a :href="politicaPrivacidad">Política de privacidad</a><br />
              <a :href="politicaCookies">Política de cookies</a><br />
            </v-col>
          </v-card-text>
        </v-col>
      </v-row>
    </v-col>

    <v-card-text id="copyright">
      <strong>
        Copyright © {{ new Date().getFullYear() }}. Ayuntamiento de Castropol.
        Todos los derechos reservados.
      </strong>
    </v-card-text>
  </v-footer>
  <!--
  <v-footer color="#cecece" class="footerWeb" v-else-if="$mq === 'tablet'">

  </v-footer>-->
  <v-footer color="#cecece" class="footerWeb" v-else>
    <v-col>
      <v-row class="contMovil" align="center" justify="center">
        <a :href="urlCastropol">
          <v-img
            class="over"
            contain
            :src="ayuntamiento"
            width="40em"
            max-width="200px"
          ></v-img>
        </a>
      </v-row>
      <v-row class="contMovil" align="center" justify="center">
        <a :href="urlCastropol">
          <v-img
            class="over"
            contain
            :src="castropol"
            width="40em"
            max-width="200px"
          ></v-img>
        </a>
      </v-row>
      <v-row>
        <v-col>
          <v-card-text>
            <v-col align="center" justify="center">
              <strong>Contacto</strong><br />
              Plaza del Ayuntamiento s/n<br />
              33760 - Castropol Asturias<br />
              985 635 001<br />
              <a href="mailto: ayuntamiento@castropol.es"
                >ayuntamiento@castropol.es</a
              ><br />
            </v-col> </v-card-text
        ></v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card-text>
            <v-col align="center">
              <a :href="avisoLegal">Aviso legal</a><br />
              <a :href="politicaPrivacidad">Política de privacidad</a><br />
              <a :href="politicaCookies">Política de cookies</a><br />
            </v-col>
          </v-card-text>
        </v-col>
      </v-row>
      <v-row>
        <v-card-text id="copyright" align="center">
          <strong>
            Copyright © {{ new Date().getFullYear() }}. Ayuntamiento de
            Castropol. Todos los derechos reservados.
          </strong>
        </v-card-text>
      </v-row>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: "FooterCastropol",
  data() {
    return {
      castropol: require("./icono-castropol.png"),
      ayuntamiento: require("./castropol.png"),
      gobAst: require("./2560px-asturias.png"),
      astNatural: require("./asturias-natural.png"),
      urlCastropol: "https://www.castropol.es/en/portada",
      urlGobAst: "https://www.asturias.es/",
      urlAstNat: "https://www.turismoasturias.es/",
      avisoLegal: "https://www.castropol.es/en/aviso-legal",
      politicaPrivacidad: "https://www.castropol.es/en/politica-de-privacidad",
      politicaCookies: "https://www.castropol.es/en/politica-de-cookies",
    };
  },
};
</script>

<style scoped>
.footerWeb {
  height: fit-content;
  width: auto;
  margin-top: 2em;
}
#copyright {
  display: flex;
  align-items: center;
  justify-content: center;
}
#astNat {
  align-items: center;
  justify-content: center;
  margin-left: 4em;
  padding: 30px 30px;
}

#contenedorInferior {
  margin-top: 0%;
  max-width: 500px;
}

.contInfImg {
  width: 5em;
}

a {
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: auto;
}

#aytoCas {
  padding: 0;
}
#gobAst {
  padding: 0;
}

.contMovil {
  margin: 1em;
}
</style>
